/* 새 버전 알림 띠.  (docs/campus/IMPLEMENT.md §2-7 ⓪)

   [왜]
   main 에 올리면 Cloudflare 가 몇 분 안에 새 화면을 내보내지만, 데스크 PC·태블릿에 열어 둔 탭은 옛 화면을 며칠씩 그대로 씁니다.
   지금은 아직 안 열어 본 메뉴를 누를 때 파일을 못 찾아 오류가 날 때만 알 수 있었습니다(ErrorBoundary).
   캠퍼스 작업처럼 '서버·규칙과 화면이 같이 바뀌어야 하는' 배포에서는 옛 탭이 캠퍼스 표시 없는 기록을 계속 만듭니다.

   [어떻게]
   지금 탭이 실행 중인 main.<해시>.js 이름과, 서버의 index.html 이 가리키는 이름을 비교합니다.
   5분마다 + 창으로 돌아올 때. 빌드 설정을 바꿀 필요가 없습니다(CRA 는 파일 이름에 내용 해시를 붙임).
   개발 서버(npm start)는 해시가 없어 비교하지 않습니다. 실패(오프라인 등)는 조용히 넘어갑니다 — 다음 확인 때 다시. */

import React, { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';

const CHECK_MS = 5 * 60 * 1000;
const MAIN_RE = /\/static\/js\/main\.([0-9a-f]{6,})\.js/;

const runningHash = () => {
    const el = Array.from(document.querySelectorAll('script[src]')).find(s => MAIN_RE.test(s.getAttribute('src') || ''));
    const m = el && (el.getAttribute('src') || '').match(MAIN_RE);
    return m ? m[1] : null;
};

export default function NewVersionBanner() {
    const [stale, setStale] = useState(false);

    useEffect(() => {
        const mine = runningHash();
        if (!mine) return undefined;
        let stopped = false;
        let last = 0;
        const check = async () => {
            if (stopped || Date.now() - last < 30 * 1000) return;
            last = Date.now();
            try {
                const res = await fetch(`/?v=${Date.now()}`, { cache: 'no-store', credentials: 'omit' });
                if (!res.ok) return;
                const m = (await res.text()).match(MAIN_RE);
                if (!stopped && m && m[1] !== mine) setStale(true);
            } catch (e) { /* 오프라인 — 다음에 */ }
        };
        const timer = setInterval(check, CHECK_MS);
        const onFocus = () => { if (document.visibilityState === 'visible') check(); };
        document.addEventListener('visibilitychange', onFocus);
        window.addEventListener('focus', onFocus);
        return () => {
            stopped = true;
            clearInterval(timer);
            document.removeEventListener('visibilitychange', onFocus);
            window.removeEventListener('focus', onFocus);
        };
    }, []);

    if (!stale) return null;
    return (
        <div role="status" className="shrink-0 bg-indigo-600 text-white px-4 py-2 text-sm font-bold flex items-center justify-center gap-3 flex-wrap">
            <span>새 버전이 나왔습니다. 저장하지 않은 입력이 없으면 새로고침해 주세요.</span>
            <button type="button" onClick={() => window.location.reload()}
                    className="inline-flex items-center gap-1.5 px-3 py-1 rounded-lg bg-white text-indigo-700 text-xs font-black hover:bg-indigo-50">
                <RefreshCw size={14} /> 새로고침
            </button>
        </div>
    );
}
